export default __webpack_public_path__ + "static/media/UserGuide_ja_JP.aea89ca4.pdf";